import { useSelector } from 'react-redux';
import { i18n } from '@lingui/core';

 
import { getAppChainId, getChains } from '../redux/selectors';

export const useAppNetwork = () => {
  const appChainId = useSelector(getAppChainId);
  const chains = useSelector(getChains);
  const chainInfo = chains[appChainId];
  if (!chainInfo) {
    throw new Error(
      i18n._('Chain with id {appChainId} not found', { appChainId }),
    );
  }

  return chainInfo;
};
